module.exports = "https://www.gc-qa.gnp.com.mx/d382ba2364b75d37354f57421de29eaf.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videos/consultar-polizas/3.png
// module id = 1019
// module chunks = 0 1